/*
 * This file should be used to define re used selectors.
 * More selectors can be found grouped on technolgyDetails, testEnvironments
 */
import { schemas } from '#oaf_schema.registry';
import { generateKeyForIterable } from '~/modules/utilities/browserUtilities';
import { lastChallengeRaised } from '~/modules/utilities/securityReviewUtilities';
import { REPORT_TYPE, getDefaultApiAuthItem, getDefaultClientAppItem, getDefaultMobileAppItem, getDefaultReportItem, getDefaultSFOrgItem, securityReviewStore } from '.';
import { publisherStore } from '../publisher/publisherStore';
import { userStore } from '../userStore';
const REPORT_NAMES = ['architectureAndUsage', 'sampleAPICallouts', 'securityScanner', 'falsePositives', 'sfCodeAnalyzer', 'otherDocs'];
const REPORT_CONFIRMATIONS = ['noFalsePositivesConfirmation', 'noSFCodeAnalyzerConfirmation'];
export function selectIsLoading(state) {
  return state.isLoading;
}
export function selectSecurityReview(state) {
  return state.securityReview;
}
export function selectSolution(state) {
  return state.solution;
}
export function selectOpsReview(state) {
  return state.securityReviewOps;
}
export function selectRaiseAChallengeText(state) {
  const challengeRaised = selectRaiseAChallenge(state);
  if (challengeRaised.challengeRaised) {
    var _lastChallengeRaised;
    return (_lastChallengeRaised = lastChallengeRaised(state.securityReview)) === null || _lastChallengeRaised === void 0 ? void 0 : _lastChallengeRaised.challenge;
  }
  return '';
}
/*
 * Plugin selectors
 */
export function selectTestEnviroments(state, isDraftState) {
  const pluginType = 'securityReview/plugins/TestEnvironments';
  let plugin = selectSecurityReview(state).plugins.find(test => test.pluginType === pluginType);
  if (!plugin) {
    plugin = securityReviewStore.upsertPlugin({
      pluginType,
      data: schemas[pluginType].new()
    }, isDraftState ? selectSecurityReview(state) : undefined);
    //Prepopulate test enviroments with generated iterator key
    plugin.data.salesforceOrgs = [getDefaultSFOrgItem()];
    plugin.data.webAppAndServices = [getDefaultApiAuthItem()];
    plugin.data.clientApps = [getDefaultClientAppItem()];
    plugin.data.mobileApps = {
      installationLinks: [getDefaultClientAppItem()],
      applications: [getDefaultMobileAppItem()]
    };
  } else {
    var _plugin$data$salesfor, _plugin$data$webAppAn, _plugin$data$clientAp, _plugin$data$mobileAp, _plugin$data$mobileAp2, _plugin$data$mobileAp3, _plugin$data$mobileAp4;
    // We must generate an iterator key for plugins already stored in OAF
    (_plugin$data$salesfor = plugin.data.salesforceOrgs) === null || _plugin$data$salesfor === void 0 ? void 0 : _plugin$data$salesfor.forEach(generateKeyForIterable);
    (_plugin$data$webAppAn = plugin.data.webAppAndServices) === null || _plugin$data$webAppAn === void 0 ? void 0 : _plugin$data$webAppAn.forEach(generateKeyForIterable);
    (_plugin$data$clientAp = plugin.data.clientApps) === null || _plugin$data$clientAp === void 0 ? void 0 : _plugin$data$clientAp.forEach(generateKeyForIterable);
    (_plugin$data$mobileAp = plugin.data.mobileApps) === null || _plugin$data$mobileAp === void 0 ? void 0 : (_plugin$data$mobileAp2 = _plugin$data$mobileAp.installationLinks) === null || _plugin$data$mobileAp2 === void 0 ? void 0 : _plugin$data$mobileAp2.forEach(generateKeyForIterable);
    (_plugin$data$mobileAp3 = plugin.data.mobileApps) === null || _plugin$data$mobileAp3 === void 0 ? void 0 : (_plugin$data$mobileAp4 = _plugin$data$mobileAp3.applications) === null || _plugin$data$mobileAp4 === void 0 ? void 0 : _plugin$data$mobileAp4.forEach(generateKeyForIterable);
  }
  return plugin.data;
}
export function selectContactInformation(state, isDraftState) {
  const pluginType = 'securityReview/plugins/ContactInformation';
  let plugin = selectSecurityReview(state).plugins.find(test => test.pluginType === pluginType);
  if (!plugin) {
    var _userStore$getState$u, _userStore$getState$u2, _publisherStore$getSt;
    plugin = securityReviewStore.upsertPlugin({
      pluginType,
      data: schemas[pluginType].new()
    }, isDraftState ? selectSecurityReview(state) : undefined);
    //Prepopulate contact information
    plugin.data.name = ((_userStore$getState$u = userStore.getState().userData) === null || _userStore$getState$u === void 0 ? void 0 : _userStore$getState$u.name) || '';
    plugin.data.primaryEmail = ((_userStore$getState$u2 = userStore.getState().userData) === null || _userStore$getState$u2 === void 0 ? void 0 : _userStore$getState$u2.realUsername) || '';
    plugin.data.secondaryEmail = ((_publisherStore$getSt = publisherStore.getState().publisher) === null || _publisherStore$getSt === void 0 ? void 0 : _publisherStore$getSt.securityReviewEmail) || '';
  }
  return plugin.data;
}
export function selectFalsePositiveInFailedSR(state, isDraftState) {
  const pluginType = 'securityReview/plugins/FalsePositive';
  let plugin = selectSecurityReview(state).plugins.find(test => test.pluginType === pluginType);
  if (!plugin) {
    plugin = securityReviewStore.upsertPlugin({
      pluginType,
      data: schemas[pluginType].new()
    }, isDraftState ? selectSecurityReview(state) : undefined);
  }
  return plugin.data;
}
export function selectReports(state, isDraftState) {
  var _selectSecurityReview, _selectSecurityReview2;
  const pluginType = 'securityReview/plugins/Reports';
  let plugin = (_selectSecurityReview = selectSecurityReview(state)) === null || _selectSecurityReview === void 0 ? void 0 : (_selectSecurityReview2 = _selectSecurityReview.plugins) === null || _selectSecurityReview2 === void 0 ? void 0 : _selectSecurityReview2.find(test => test.pluginType === pluginType);
  if (!plugin) {
    plugin = securityReviewStore.upsertPlugin({
      pluginType,
      data: schemas[pluginType].new()
    }, isDraftState ? selectSecurityReview(state) : undefined);
  }
  getReports(plugin);
  return plugin.data;
}
function getReports(plugin) {
  if (plugin) {
    for (let i = 0; i < REPORT_NAMES.length; i++) {
      if (!plugin.data[REPORT_NAMES[i]]) {
        plugin.data[REPORT_NAMES[i]] = [getDefaultReportItem()];
      } else {
        var _plugin$data$REPORT_N;
        (_plugin$data$REPORT_N = plugin.data[REPORT_NAMES[i]]) === null || _plugin$data$REPORT_N === void 0 ? void 0 : _plugin$data$REPORT_N.forEach(generateKeyForIterable);
      }
    }
    for (let i = 0; i < REPORT_CONFIRMATIONS.length; i++) {
      if (!plugin.data[REPORT_CONFIRMATIONS[i]]) {
        plugin.data[REPORT_CONFIRMATIONS[i]] = false;
      }
    }
  }
}
export function selectRaiseAChallenge(state, isDraftState) {
  var _selectSecurityReview3;
  const pluginType = 'securityReview/plugins/RaiseAChallenge';
  let plugin = (_selectSecurityReview3 = selectSecurityReview(state)) === null || _selectSecurityReview3 === void 0 ? void 0 : _selectSecurityReview3.plugins.find(test => test.pluginType === pluginType);
  if (!plugin) {
    plugin = securityReviewStore.upsertPlugin({
      pluginType,
      data: schemas[pluginType].new({
        challenges: [],
        challengeRaised: false
      })
    }, isDraftState ? selectSecurityReview(state) : undefined);
  }
  return plugin.data;
}

/*
 * Nested Selectors
 */
export function selectArchitectureReports(state) {
  return selectReports(state).architectureAndUsage;
}
export function selectSampleApiReports(state) {
  return selectReports(state).sampleAPICallouts;
}
export function selectSecurityScannerReports(state) {
  return selectReports(state).securityScanner;
}
export function selectFalsePositivesReports(state) {
  return selectReports(state).falsePositives;
}
export function selectSFCodeAnalyzerReports(state) {
  return selectReports(state).sfCodeAnalyzer;
}
export function selectOtherDocsReports(state) {
  return selectReports(state).otherDocs;
}
export function selectReportItemsByType(state, reportType) {
  let reportItems;
  switch (reportType) {
    case REPORT_TYPE.architectureAndUsage:
      reportItems = selectArchitectureReports(state);
      break;
    case REPORT_TYPE.sampleAPICallouts:
      reportItems = selectSampleApiReports(state);
      break;
    case REPORT_TYPE.securityScanner:
      reportItems = selectSecurityScannerReports(state);
      break;
    case REPORT_TYPE.falsePositives:
      reportItems = selectFalsePositivesReports(state);
      break;
    case REPORT_TYPE.sfCodeAnalyzer:
      reportItems = selectSFCodeAnalyzerReports(state);
      break;
    case REPORT_TYPE.otherDocs:
      reportItems = selectOtherDocsReports(state);
      break;
    default:
      console.error('Invalid report type', reportType);
      break;
  }
  return reportItems || [];
}
export function selectOpsFeedback(state) {
  var _selectOpsReview, _selectOpsReview$plug;
  const pluginType = 'securityReviewOps/plugins/SRFeedback';
  const plugin = (_selectOpsReview = selectOpsReview(state)) === null || _selectOpsReview === void 0 ? void 0 : (_selectOpsReview$plug = _selectOpsReview.plugins) === null || _selectOpsReview$plug === void 0 ? void 0 : _selectOpsReview$plug.find(test => test.pluginType === pluginType);
  return plugin === null || plugin === void 0 ? void 0 : plugin.data;
}
export function selectOpsAttemptsCount(state) {
  var _selectOpsReview$atte;
  return (_selectOpsReview$atte = selectOpsReview(state).attemptsCount) !== null && _selectOpsReview$atte !== void 0 ? _selectOpsReview$atte : 0;
}